// @flow

import React from "react";
import { Typography } from "src/latest/src/components";
import Input from "../Input/Input";
import "./NodeCheckBox.scss";
import checkGreen from "../../../../../assets/icons/icon-checkmark-green.svg";
import check from "../../../../../assets/icons/icon-checkmark.svg";
import MiniCheckBox from "./../MiniCheckBox/MiniCheckBox";
import {
    sequenceQuestionnaireArray,
    stringToObject,
} from "../../../../../legacy/utils/helpers";
import { noop } from "react-bootstrap-typeahead/types/utils";

type Props = {
    className?: string,
    selected: boolean,
    onCheck: Function,
    title: string,
    isBordered?: boolean,
    isFill?: boolean,
    hasOther?: boolean,
    onChange?: Function,
    inputValue?: any,
    onFocus?: Function,
    onBlur?: Function,
    onHover?: Function,
    isCircle?: boolean,
    isFocused?: boolean,
    id?: string,
    nodes?: Array,
    onNodeCheck: Function,
    onOtherValueChange: Function,
};

const RenderNodes = (
    cnodes,
    depth = 0,
    onClick: Function,
    onValueChange: Function,
    id
) => {
    cnodes = sequenceQuestionnaireArray(cnodes);

    return (
        cnodes &&
        cnodes.length !== 0 && (
            <ul
                key={id}
                className={
                    (depth++ === 0 ? "parent-node" : "") + " expand active"
                }
            >
                {cnodes.map((node) => {
                    const metadata = stringToObject(node.metadata || "");

                    return (
                        <li key={id + node.id}>
                            <div className="mini-check-box active-parent ">
                                <MiniCheckBox
                                    onClick={onClick}
                                    id={id + "-" + node.id}
                                    text={node.title}
                                    value={node.title}
                                    selected={node.selected || false}
                                    hasOther={metadata.has_other}
                                    onChange={onValueChange}
                                    inputValue={node.value}
                                />
                            </div>
                            {node.selected &&
                                node.nodes &&
                                RenderNodes(
                                    node.nodes,
                                    depth,
                                    onClick,
                                    onValueChange,
                                    id + "-" + node.id
                                )}
                        </li>
                    );
                })}
            </ul>
        )
    );
};

export default function NodeCheckBox({
    className = "",
    onOtherValueChange,
    selected = false,
    onCheck,
    title,
    isBordered = true,
    isFill = false,
    hasOther,
    onChange = noop,
    inputValue,
    onFocus = noop,
    onBlur = noop,
    onHover,
    isCircle,
    id,
    nodes,
    onNodeCheck,
}: Props): React$Element<any> {
    const onChildClick = (ChildChecked, nodeId) => {
        onNodeCheck(ChildChecked, nodeId);
    };

    const onValueChange = (value: string, nodeId: stirng) => {
        let finalValue = "";

        if (value === " " || value === "  ") finalValue = "";
        else if (value?.includes("  ")) finalValue = value.trim();
        else finalValue = value;
        onOtherValueChange(finalValue, nodeId);
    };

    const onInputValueChanges = (e: any) => {
        let finalValue = "";
        const value = e?.target?.value;

        if (value === " " || value === "  ") finalValue = "";
        else if (value?.includes("  ")) finalValue = value.trim();
        else finalValue = value;
        onChange(finalValue);
    };

    const onSelected = (e: Event, _id: string, _selected: boolean) => {
        if (e?.target?.nodeName !== "INPUT") onCheck(_id, _selected);
    };

    return (
        <>
            <div
                onMouseEnter={onHover}
                onClick={(e) => onSelected(e, id, !selected)}
                className={`node-check-box ${className} ${
                    isBordered && selected
                        ? hasOther && !inputValue
                            ? "-error-bordered"
                            : "-bordered"
                        : "unchecked"
                } ${isFill && selected ? "-fill" : ""}`}
            >
                <span
                    className={`node-check-box__check ${
                        isCircle ? "-circle" : ""
                    } ${selected && !isFill ? "checked" : "-fill__checked"}`}
                >
                    {!isCircle ? (
                        <img
                            className={`${!selected ? "d-none" : ""}`}
                            src={isFill ? checkGreen : check}
                            alt="check"
                        />
                    ) : (
                        <span />
                    )}
                </span>
                {selected && hasOther ? (
                    <Input
                        readOnly={!selected}
                        id={`input_${title}`}
                        checkbox={true}
                        onFocus={onFocus}
                        autoFocus={true}
                        onBlur={onBlur}
                        onKeyDown={(e) => e.key === "Enter" && onBlur()}
                        placeholder={title}
                        value={inputValue}
                        onChange={onInputValueChanges}
                    />
                ) : (
                    <Typography
                        variant="size-16"
                        weight="semi-bold"
                        color={`color-2${!selected ? "8" : ""}`}
                        className="custom-check-box__title"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                )}
            </div>
            {selected &&
                nodes.length > 0 &&
                RenderNodes(nodes, 0, onChildClick, onValueChange, id)}
        </>
    );
}
